<template>
  <v-row justify="center" align="center">
    <v-col cols="12" lg="6" align="center">
      <v-card class="padding-20">
        <v-card-title>Add Community</v-card-title>
        <v-subheader>Community Code: {{ community.code }}</v-subheader>
        <v-card-text class="padding-10">
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="community.name"
              label="Name"
              outlined
              required
              :rules="requiredRules"
            ></v-text-field>
            <v-select
              v-model="community.plan"
              label="Plan"
              :items="plans"
              outlined
              required
              :rules="requiredRules"
            ></v-select>
            <v-text-field
              v-model="community.members"
              label="Level"
              type="number"
              min="100"
              outlined
              required
              :rules="requiredRules"
            ></v-text-field>
            <v-text-field
              v-model="community.city"
              label="City"
              outlined
              required
              :rules="requiredRules"
            ></v-text-field>
            <v-alert
              v-if="alert.message != ''"
              :type="alert.type"
              :color="alert.type"
              outlined
              >{{ alert.message }}</v-alert
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addCommunity">Submit</v-btn>
              <v-btn color="error" text to="/admin">Close</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { communitiesRef } from "../../firebaseApp";
import communityObject from "../json/community.json";
import plansOptions from "../json/plans.json";

export default {
  data: () => ({
    community: communityObject,
    plans: plansOptions,
    existingCommunities: [],
    alert: {
      type: "",
      message: "",
    },
    requiredRules: [(v) => !!v || "Required"],
  }),
  methods: {
    generateCode() {
      var code = Math.random().toString(36).substring(2, 15);
      this.community.code = code;
    },
    addCommunity() {
      if (this.$refs.form.validate()) {
        this.community.dateAdded = Date.now();
        if (this.isUnique("code"))
          if (this.isUnique("name")) {
            communitiesRef.push(this.community).key;
            this.alert.message =
              this.community.name + " has been successfully added";
            this.$refs.form.reset();
            this.generateCode();
            this.alert.type = "success";
          } else {
            this.alert.type = "error";
            this.alert.message =
              "A community has already been registered under the same name. Please use a different one";
            this.community.name = "";
          }
        else {
          this.generateCode();
          this.addCommunity();
        }
      }
    },
    isUnique(prop) {
      let value = this.community[prop];
      let isUnique = true;
      this.communities.forEach((existingCommunity) => {
        if (value == existingCommunity.val()[prop]) {
          isUnique = false;
        }
      });
      return isUnique;
    },
    loadExistingCommunities() {
      communitiesRef.on("value", (snap) => {
        let communities = [];
        snap.forEach((community) => {
          communities.push(community);
        });
        this.communities = communities;
      });
    },
  },
  mounted() {
    this.generateCode();
    this.loadExistingCommunities();
  },
};
</script>